<template>
    <v-layout id="footer" fill-height>
        <v-row style="text-align:left">
            <v-col cols="4" offset-md="1" md="2">
                <div class="footer-category">문의</div>
                <div class="footer-info"><a href="mailto:help@everybike.io">이메일</a></div>
                <div class="footer-info"><a href="http://pf.kakao.com/_mpLxhK/chat">카카오톡</a></div>
                <div class="footer-info"><a href="https://www.instagram.com/everybike_official/">인스타그램</a></div>
                <div class="footer-info"><a href="mailto:bon@everybike.io">광고/제휴</a></div>
            </v-col>
            <v-col cols="8" md="4">
                <div class="footer-category">고객센터</div>
                <!-- <div class="footer-info"><span class="footer-subcategory">전화문의</span> <a href="tel:1666-3710">1666-3710</a></div> -->
                <div class="footer-info"><span class="footer-subcategory">카카오톡</span> <a href="http://pf.kakao.com/_mpLxhK/chat">@에브리바이크</a></div>
                <div class="footer-info"><span class="footer-subcategory">업무시간</span> <span>10:00~18:00</span></div>
                <div class="footer-info"><span class="footer-subcategory">점심시간</span> <span>12:30~13:30</span></div>
            </v-col>
            <hr style="width:100%;opacity: 0.2" v-if="$vuetify.breakpoint.smAndDown"/>
            <v-col cols="12" md="5">
                <div class="footer-category">회사정보</div>
                <div class="footer-info">주식회사 에브리바이크 | 대표: 구본영</div>
                <div class="footer-info">사업자등록번호: 368-81-01807</div>
                <div class="footer-info">통신판매: 2020-서울서초-1619</div>
                <div class="footer-info">주소: 서울특별시 관악구 호암로 597, ktbridge lab 3층 1호</div>
                <div class="footer-info">팩스: 0504-225-1664</div>
                <div class="footer-info terms-and-privacy">
                    <a href="https://docs.everybike.io/terms" target="blank" class="pr-3">이용약관</a>
                    <a href="https://docs.everybike.io/privacy" target="blank">개인정보처리방침</a>
                </div>
                <div class="footer-info pt-3">Copyrightⓒ{{year}} 에브리바이크 All rights reserved</div>
            </v-col>
        </v-row>
    </v-layout>
</template>

<script>
  export default {
    data: () => ({
      year: new Date().getFullYear()
    })
  }
</script>

<style lang="scss">
    #footer {
        padding-top: 32px;
        max-width: 1080px;
        margin-left: auto;
        margin-right: auto;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #777777;
        a{
            /*text-decoration: none!important;*/
            text-underline: #777777;;
            color: #777777;
        }
        @media screen and (max-width: 1280px) {
            padding-left: 30px;
            padding-right: 30px;
            padding-bottom: 30px;
        }
        .terms-and-privacy{
            font-weight: bold;
            color: #1f1f1f;
        }
    }

    .footer {
        &-category {
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #555555;
            padding-bottom: 17px;
        }

        &-info{
            padding-bottom: 7px;
        }

        &-subcategory {
            font-size: 13px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #555555;
            padding-right: 12px;
        }
    }
</style>
